export const StoreTypes: Record<StoreType, StoreTypeKey> = {
  PREMIUM: 'Premium',
  TIP_PURCHASE: 'TipPurchase',
};

export const StoreTypesReversed: Record<StoreTypeKey, StoreType> = {
  Premium: 'PREMIUM',
  TipPurchase: 'TIP_PURCHASE',
};

export type StoreType = 'PREMIUM' | 'TIP_PURCHASE';
export type StoreTypeKey = 'Premium' | 'TipPurchase';
